import React from "react";
import PropTypes from "prop-types";

import BluInputElt from "./BluInputElt";

export const getBluFilterElt = ({
  INPUT_MAX_LENGTH,
  INPUT_PLACEHOLDER,
  INPUT_REGEX_COMPLETE,
  INPUT_REGEX_PARTIAL,
}) => {
  const BluFilterElt = (props) => {
    const { filterValue, fieldName, setFilter } = props;

    const update = (value) => {
      setFilter({ fieldName, filter: { value } });
    };

    return (
      <BluInputElt
        inputValue={filterValue}
        maxLength={INPUT_MAX_LENGTH}
        placeholder={INPUT_PLACEHOLDER}
        regexComplete={INPUT_REGEX_COMPLETE}
        regexPartial={INPUT_REGEX_PARTIAL}
        updateValue={update}
      />
    );
  };

  BluFilterElt.propTypes = {
    filterValue: PropTypes.string,
    fieldName: PropTypes.string,
    setFilter: PropTypes.func,
  };

  BluFilterElt.defaultProps = {
    filterValue: "",
    fieldName: "",
    setFilter: () => {},
  };

  return BluFilterElt;
};
